import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AuthSuccess = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('userId');

    if (token && userId) {
      // Store token and userId in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);

      // Redirect to home page
      setTimeout(() => {
        navigate('/');
        window.location.reload(); // Reload to update Redux state
      }, 500);
    } else {
      // No token or userId, redirect to login
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#0f0f0f',
      color: '#1dd1a1'
    }}>
      <h1>🔄 {t('common.authenticating') || 'Authenticating...'}</h1>
      <p>{t('common.redirecting') || 'Redirecting you to home...'}</p>
    </div>
  );
};

export default AuthSuccess;
